import { render, staticRenderFns } from "./DepositTiming.vue?vue&type=template&id=1c31404d&scoped=true&"
import script from "./DepositTiming.vue?vue&type=script&lang=js&"
export * from "./DepositTiming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c31404d",
  null
  
)

export default component.exports